<div class="col full-height layout-row" [ngClass]="{'excluded': !!resource.excluded, 'selected': isSelected}"
     (click)="onDrilldownClick($event)">

  <!--  <div *ngIf="item.handle"-->
  <!--    class="drag-handle align-self-center mx-3 my-0"-->
  <!--    dndHandle-->
  <!--    matListItemIcon>-->
  <!--    <bringoz-icon icon-name="account"></bringoz-icon>-->
  <!--  </div>-->

  <div *ngIf="draft" class="layout-column layout-align-center-center">
    <div class="index-border margin-left-10 margin-right-10" [style.background-color]="routeColor"></div>
  </div>

  <div class="flex layout-row layout-wrap info-container">

    <!--Link Row-->
    <div class="layout-row layout-align-start-center gap-5 full-width">

      <!-- Edit Resource Allocation Button -->
      <bringoz-button type="tertiary"
                      appBringozIdGenerator="edit-resource-resource-card-resources"
                      size="fit"
                      class="edit-resource-btn"
                      *ngxPermissionsOnly="'planning.update'"
                      (onClick)="onEditResourceAllocation.emit({resource, route, event: $event});$event.stopPropagation();"
                      [ngbTooltip]="('Edit Resource Allocation' | translate)">
        <bringoz-icon iconName="edit-outline" classSize="sm"
                      [fill]="resource.excluded ? '#CCCCCC' : '#484848'"></bringoz-icon>
      </bringoz-button>

      <div class="flex layout-row layout-align-start-center gap-5">
        <span
          class="flex br-body-1 resource-title layout-row layout-align-start-center">
          <app-bringoz-checkbox [isChecked]="isSelected"
                                appBringozIdGenerator="checkbox-resource-card-resources"
                                (clickEvent)="onToggle.emit(!isSelected); $event.stopPropagation()">
          </app-bringoz-checkbox>
          {{ 'Resource' | translate }} {{ resource.allocationName || resource.vehicleName }}</span>
        <span *ngIf="!resource.allocationId" class="br-body-1">X{{ resource.amount || '---' }}</span>
      </div>

      <div ngbDropdown container="body">
        <button (click)="$event.stopPropagation();"
                appBringozIdGenerator="menu-resource-card-resources"
                class="action-menu"
                ngbDropdownToggle aria-labelledby="action-menu">
          <bringoz-icon iconName="menu" class="gray-102"></bringoz-icon>
        </button>
        <div ngbDropdownMenu>
          <button
            ngbDropdownItem
            appBringozIdGenerator="dispatch-routes-resource-card-menu-resources"
            type="tertiary"
            (click)="onDispatch.emit(resource.id);$event.stopPropagation()">
            <div class="layout-row layout-align-start-center">
              <bringoz-icon iconName="dispatch" class="gray-102 margin-right-10" classSize="xl"></bringoz-icon>
              <span class="br-body-2 font-weight-400">{{ 'Dispatch Routes' | translate }}</span>
            </div>
          </button>
        </div>
      </div>

      <div *ngIf="canClose" class="layout-row layout-align-center-center gap-0">
        <bringoz-button type="tertiary"
                        size="fit"
                        [ngbTooltip]="'Back'"
                        (onClick)="onClose.emit();$event.stopPropagation();">
          <bringoz-icon iconName="arrow-left" classSize="lg" fill="#484848"></bringoz-icon>
        </bringoz-button>
      </div>

    </div>

    <!--Time Window Row-->
    <div *ngIf="settings?.columns?.timeWindow" class="flex-100 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="time-window-outline"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Time Window' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ resource | timeWindow }}</span>
    </div>

    <!--Vehicle Type Row-->
    <div *ngIf="settings.columns.vehicle"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row text-ellipsis gap-5 ">
      <bringoz-icon [iconName]="resource.vehicleClass?.toLowerCase() || 'truck'"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Vehicle' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ resource.vehicleType?.name || '---' }}</span>
    </div>


    <!--Vehicle Row-->
    <div *ngIf="settings?.columns?.logisticVehicle && !itemElementSize" class="flex-100 layout-row info-row gap-5">

      <!--Main Logistic Vehicle-->
      <div class="flex layout-row layout-align-start-center text-ellipsis gap-5">
        <bringoz-icon [iconName]="resource.mainLogisticsVehicleReference?.vehicleType?.toLowerCase() || 'truck'"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'Logistic Vehicle' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ resource.mainLogisticsVehicleReference?.name || '---' }}</span>
      </div>

      <!--Attached Logistic Vehicle-->
      <div *ngFor="let vehicle of resource.attachedLogisticsVehicleReferences;"
           class="flex layout-row layout-align-start-center text-ellipsis gap-5">
        <bringoz-icon [iconName]="vehicle.vehicleType?.toLowerCase() || 'Trailer'"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'Attached Logistic Vehicle' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ vehicle.name || '---' }}</span>
      </div>

    </div>

    <ng-container *ngIf="settings?.columns?.logisticVehicle && !!itemElementSize">
      <!--Main Logistic Vehicle-->
      <div class="layout-row layout-align-start-center text-ellipsis gap-5 "
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'">
        <bringoz-icon [iconName]="resource.mainLogisticsVehicleReference?.vehicleType?.toLowerCase() || 'truck'"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'Logistic Vehicle' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ resource.mainLogisticsVehicleReference?.name || '---' }}</span>
      </div>

      <!--Attached Logistic Vehicle-->
      <div *ngFor="let vehicle of resource.attachedLogisticsVehicleReferences;"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class="layout-row layout-align-start-center text-ellipsis gap-5 ">
        <bringoz-icon [iconName]="vehicle.vehicleType?.toLowerCase() || 'Trailer'"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'Attached Logistic Vehicle' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ vehicle.name || '---' }}</span>
      </div>
    </ng-container>

    <!--Agent Row-->
    <div *ngIf="settings.columns.agent"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row text-ellipsis gap-5 ">
      <bringoz-icon iconName="agent"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Agent' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ resource.agentName || '---' }}</span>
    </div>

    <!--Skills Row-->
    <div *ngIf="settings?.columns?.skills"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="tag-outline"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Skills' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span *ngIf="!resource.allocationSkills?.length" class="br-body-1 text-ellipsis">---</span>
      <app-skill-tags class="flex" [skillsIds]="resource.allocationSkills"></app-skill-tags>
    </div>


    <!--Labels Row-->
    <div *ngIf="settings?.columns?.labels"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="label-outline"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Labels' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-labels-display *ngIf="!!resource.labels?.length"
                                  [labels]="resource.labels"
                                  maxItems="1">

      </app-bringoz-labels-display>
      <span *ngIf="!resource.labels?.length" class="br-body-1 text-ellipsis">---</span>
    </div>

    <!--Tags Row-->
    <div *ngIf="settings?.columns?.tags"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="tag-outline"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Tags' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-tags *ngIf="!!resource.tags?.length"
                        [tags]="resource.tags"
                        [maxTags]="1">
      </app-bringoz-tags>
    </div>

    <!--Carrier row-->
    <div *ngIf="settings?.columns?.carrier"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="carrier"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Carrier' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-state-link *ngIf="!!resource.businessCarrierReference"
                              class="flex text-ellipsis"
                              [state]="'accounts-detail-supply.info.preferences'"
                              [permission]="'accounts.supply.get'"
                              [params]="{id: resource.businessCarrierReference.id}"
                              [text]="resource.businessCarrierReference.name">
      </app-bringoz-state-link>
      <span *ngIf="!resource.businessCarrierReference" class="br-body-1 text-ellipsis">---</span>
    </div>


    <!--Load - Weight-->
    <div *ngIf="settings?.load?.weight"
         class="flex-25 layout-row layout-align-start-center info-row gap-5 text-ellipsis">
      <bringoz-icon iconName="weight"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Weight' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ resource.capacity.weight | bringozWeight:true:'---' }}</span>
    </div>

    <!--Load - Volume-->
    <div *ngIf="settings?.load?.volume"
         class="flex-25 layout-row layout-align-start-center info-row gap-5 text-ellipsis">
      <bringoz-icon iconName="volume"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Volume' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ resource.capacity.dimensions?.cube | bringozVolume: false:'---' }}</span>
    </div>

    <!--Load - Packages-->
    <div *ngIf="settings?.load?.packages"
         class="flex-25 layout-row layout-align-start-center info-row gap-5 text-ellipsis">
      <bringoz-icon iconName="package-outline"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Packages' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ resource.capacity.numberOfPackages || '---' }}</span>
    </div>

    <!--Load - Spots-->
    <div *ngIf="settings?.load?.spots"
         class="flex-25 layout-row layout-align-start-center info-row gap-5 text-ellipsis">
      <bringoz-icon iconName="spot"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Spots' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ resource.capacity.numberOfSpots || '---' }}</span>
    </div>

    <!--Load - Pallets-->
    <div *ngIf="settings?.load?.pallets"
         class="flex-25 layout-row layout-align-start-center info-row gap-5 text-ellipsis">
      <bringoz-icon iconName="pallets"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Pallets' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ resource.capacity.numberOfPallets || '---' }}</span>
    </div>

    <!--Load - Value-->
    <div *ngIf="settings?.load?.value"
         class="flex-25 layout-row layout-align-start-center info-row gap-5 text-ellipsis">
      <bringoz-icon iconName="dollar-circle"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Value' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-2 route-total-income"
            [ngClass]="getTotalIncomeClass(route?.totals?.totalIncome)">{{ route?.totals?.totalIncome | bringozPrice: '---' }}</span>
    </div>

    <!--Capacity Row-->
    <div
      *ngIf="settings.capacity?.weight || settings.capacity?.volume || $any(settings.capacity)?.packages || $any(settings.capacity)?.spots"
      [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
      class=" layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="packages"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Capacity' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-primary-capacity class="flex"
                                    [weightEnabled]="settings.capacity?.weight"
                                    [volumeEnabled]="settings.capacity?.volume"
                                    [packagesEnabled]="$any(settings.capacity)?.packages"
                                    [spotsEnabled]="$any(settings.capacity)?.spots"
                                    [weight]="route?.totals?.totalLoad"
                                    [maxWeight]="resource?.capacity?.weight"
                                    [volume]="route?.totals?.totalVolume"
                                    [maxDimensions]="resource?.capacity?.dimensions"
                                    [packages]="route?.totals?.totalPackagesCount"
                                    [maxPackages]="resource?.capacity?.numberOfPackages"
                                    [spots]="route?.totals?.totalSpots"
                                    [maxSpots]="resource?.capacity?.numberOfSpots">

      </app-bringoz-primary-capacity>


      <!--      <bringoz-icon [iconName]="capacity.icon"-->
      <!--                    classSize="sm"-->
      <!--                    fill="#484848"-->
      <!--                    [ngbTooltip]="capacity.type | translate"-->
      <!--                    openDelay="300">-->

      <!--      </bringoz-icon>-->
      <!--      <app-bringoz-capacity-bar class="flex"-->
      <!--                                [value]="capacity.percentage"-->
      <!--                                [ngbTooltip]="capacityTooltip"-->
      <!--                                openDelay="300">-->

      <!--      </app-bringoz-capacity-bar>-->
      <!--      <span class="br-body-1">{{capacity.percentage}}%</span>-->

      <!--      <ng-template #capacityTooltip>-->
      <!--        <div class="layout-row layout-align-start-center gap-5">-->
      <!--          <span class="br-body-1">{{capacity.type | translate}}:</span>-->
      <!--          <span class="br-body-1">{{capacity.value}}/{{capacity.maxValue}}</span>-->
      <!--        </div>-->
      <!--      </ng-template>-->

    </div>

    <!--Routes Count-->
    <div *ngIf="settings?.columns.routesCount"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="hash"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Routes Count' | translate"
                    openDelay="300">
      </bringoz-icon>
      <span class="br-body-2">
        {{ (resourceRoutes?.length === 1 ? 'X_ROUTE' : 'X_ROUTES') | translate: { sum: (resourceRoutes?.length || 0) } }}
      </span>
    </div>

    <!--Routes Names-->
    <div *ngIf="settings?.columns.routesNames"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="route"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Routes Names' | translate"
                    openDelay="300">
      </bringoz-icon>
      <span class="br-body-2">
        <app-bringoz-items-list-display flex
                                        [itemsList]="{list: resourceRoutes, displayKey: 'name'}"
                                        [maxItems]="1">
        </app-bringoz-items-list-display>
      </span>
    </div>

    <!--Total Duration-->
    <div *ngIf="settings?.columns.totalDuration"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="timer-outline"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Total Duration' | translate"
                    openDelay="300">
      </bringoz-icon>
      <span class="br-body-2">
        {{ totalDuration | bringozTimeConvert }}
      </span>
    </div>
    <!--    &lt;!&ndash;Value Row&ndash;&gt;-->
    <!--    <div class="layout-row info-row gap-5">-->

    <!--      &lt;!&ndash;Package Value&ndash;&gt;-->
    <!--      <div *ngIf="route?.totals?.value" class="layout-row layout-align-start-center text-ellipsis">-->
    <!--        <bringoz-icon [iconName]="'dollar-circle'"-->
    <!--                      [classSize]="'sm'">-->

    <!--        </bringoz-icon>-->
    <!--        <span class="br-body-1">{{'Value' | translate}} {{route?.totals?.value | bringozPrice}}</span>-->
    <!--      </div>-->

    <!--      &lt;!&ndash;Income&ndash;&gt;-->
    <!--      <div *ngIf="route?.totals?.totalIncome" class="layout-row layout-align-start-center text-ellipsis">-->
    <!--        <bringoz-icon [iconName]="'dollar-circle'"-->
    <!--                      [classSize]="'sm'">-->

    <!--        </bringoz-icon>-->
    <!--        <span class="br-body-1">{{'Income' | translate}} {{route?.totals?.totalIncome | bringozPrice}}</span>-->
    <!--      </div>-->

    <!--    </div>-->


  </div>

</div>
